export const SET_SQUAD_CAPACITY_AS_DIRTY_FOR_SETUP = 'SET_SQUAD_CAPACITY_AS_DIRTY_FOR_SETUP';
export const SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY = 'SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY';
export const DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY = 'DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY';
export const HIDE_CAPACITY_DIALOG = 'HIDE_CAPACITY_DIALOG';
export const DISPLAY_CAPACITY_DIALOG = 'DISPLAY_CAPACITY_DIALOG';
export const DISPLAY_EVENTS_IN_DDL = 'DISPLAY_EVENTS_IN_DDL';
export const SET_SQUAD_VISIBILITY = 'SET_SQUAD_VISIBILITY';



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/constants.js